
import { castTRMarketForELC } from "../../constantes/utilitaries";
import i18n from "../../i18nextInit";
import { Category, Product, Status } from "../../type";
import { getLokiInfosProducts } from "./lokiProducts";

export type ProductBaseIdRequest = { prodBaseId: string, category: Category, priority: number, skuID: string, instoreSku: string, variantIds?: string[] }
type ELCProductRequestOptions = { buidLang?: string }

export const getELCInfosProducts = async (base_IDs: ProductBaseIdRequest[], market: string, options: ELCProductRequestOptions = {}) => {
    if (base_IDs.length === 0) {
        return []
    }

    // Route the actual US and UK markets, before legacy market aliases are applied.
    if (market === "US" || market === "UK") {
        return getLokiInfosProducts(base_IDs, market)
    }

    let origin: string = "https://beta-clinicalreality.imaaagery.app"
    if (window.location.href.includes("localhost")) {
        origin = "https://localhost:6006"
    }

    if (window.location.href.includes("qa-ccr")) {
        origin = "https://qa-ccr.imaaagery.app"
    } else if (window.location.href.includes("ccr")) {
        origin = "https://ccr.imaaagery.app"
    }

    //Cas pour les TR (Travel retailers)
    if (market.includes("TR") && market !== "TR") {
        market = castTRMarketForELC(market)
    }

    let ELCMarket = getELCMarket(market)

    let BUIDmarket = ELCMarket.toLowerCase()

    if(BUIDmarket === "co"){
        BUIDmarket = "cl"
    }
    let BUIDlang = options.buidLang ?? i18n.language.slice(0, 2).toLowerCase()

    // cas particulier pour hong kong (ZhHk)
    if (!options.buidLang && (i18n.language === "ZhHk" || i18n.language === "ZhTw")) {
        BUIDlang = "zhhant"
    }
    if (!options.buidLang && i18n.language === "CnCn") {
        BUIDlang = "zhhans"
    }

    let buid = "2-cl-" + BUIDmarket + "-" + BUIDlang + "-ecommv1"
    // eslint-disable-next-line no-restricted-globals
    let token = window.btoa(buid + ":" + origin)

    let myHeaders = new Headers();
    // myHeaders.append("authorizationtoken", "Mi1jbC11cy1lbi1lY29tbXYxOmh0dHBzOi8vbG9jYWxob3N0OjYwMDY="); // 2-cl-us-en-ecommv1:https://www.clinique.com
    myHeaders.append("authorizationtoken", token);//localhost:6006
    myHeaders.append("business-unit", buid);
    myHeaders.append("clientId", "clinicalreality");
    myHeaders.append("content-type", "application/json");
    // myHeaders.append("origin", "https://localhost:6006");
    myHeaders.append("origin", origin);

    const uniqueBaseIds = getUniqueProductBaseIds(base_IDs)
    let string = uniqueBaseIds.map(function (item) { return '"' + item.prodBaseId + '"' }).join(',')
    const graphql = JSON.stringify({
        query: "{\n    products(environment: {prod:true},\n        filter: [{product_id:{in:[" + string + "]}}],\n        sort: []\n    ) \n    {\n        items {\n            product_id\n        product_url\n            display_name\n            short_description\n            time_of_use {\n                        key\n                        value\n                    }\n            skus {\n                items {\n                    inventory_status\n                    sku_id\n                    prices {\n                        currency\n                        is_discounted\n                        include_tax {\n                            price\n                            original_price\n                            price_per_unit\n                            price_formatted\n                            original_price_formatted\n                            price_per_unit_formatted\n                        }\n                    }\n                    sizes {\n                        value\n                        key\n                    }\n                    shades {\n                        name\n                        description\n                        hex_val\n                        image {\n                            src\n                            height\n                            width\n                        }\n                    }\n                    media {\n                        large {\n                            src\n                            alt\n                            height\n                            width\n                        }\n                        medium {\n                            src\n                            alt\n                            height\n                            width\n                        }\n                        small {\n                            src\n                            alt\n                            height\n                            width\n                        }\n                    }\n                }\n            }\n            media {\n                large {\n                    src\n                    alt\n                    height\n                    width\n                }\n                medium {\n                    src\n                    alt\n                    height\n                    width\n                }\n                small {\n                    src\n                    alt\n                    height\n                    width\n                }\n            }\n            usage {\n                content\n                label\n                type\n            }\n        }                    \n    }\n}",
        variables: {}
    })

    let products = await fetch(getELCURL(market), {// https://emea.sdapi.io/stardust-prodcat-product-v3/graphql/core/v1/extension/v1
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    })
        .then(response => response.json())
        .then(result => { return parseProductFromELC(result, base_IDs) })
        .catch(error => console.log('error', error));

    return products!
}

const getUniqueProductBaseIds = (base_IDs: ProductBaseIdRequest[]): ProductBaseIdRequest[] => {
    const seenBaseIds = new Set<string>()

    return base_IDs.filter((item) => {
        if (seenBaseIds.has(item.prodBaseId)) {
            return false
        }

        seenBaseIds.add(item.prodBaseId)
        return true
    })
}

const handleInventoryStatus = (_status: string): Status => {
    if (_status === "Temporarily out of stock") {
        return Status.oos
    }

    if (_status === "Sold Out") {
        return Status.oos
    }

    if (_status === "Do Not Display") {
        return Status.doNotDisplay
    }

    if (_status === "Free Promo") {
        return Status.doNotDisplay
    }

    return Status.active
}

const parseProductFromELC = (json: any, base_IDs: { prodBaseId: string, category: Category, priority: number, skuID: string, instoreSku: string }[]) => {
    let resProducts: Product[] = []

    if (!json["data"]) {
        base_IDs.forEach(product => {
            resProducts.push({
                base_id: product.prodBaseId,
                images: [],
                instoreSku: product.instoreSku,
                name: "",
                price: "0",
                priority: product.priority,
                prod_base_id: product.prodBaseId,
                skuID: product.skuID,
                sppURL: "",
                tags: []
            })
        })

        return resProducts
    }

    if (!json["data"]["products"]) {

        return []
    }

    json["data"]["products"]["items"].forEach((item: any) => {
        let product: Product = { base_id: "none", instoreSku: "", images: [], name: "", price: "", prod_base_id: "", tags: [], priority: 0, skuID: "", sppURL: "" }

        product.prod_base_id = item["product_id"]

        // name handling
        product.name = item["display_name"]
        product.texts = []
        product.sppURL = item["product_url"]

        // Price handling, depending on items
        if (item["skus"]) {
            product.items = []
            item["skus"]["items"].forEach((item: any) => {
                // Cas pour taiwan ou je n'affiche pas les "free product"
                if (item["prices"][0]["include_tax"]["price_formatted"] !== 'TWD0') {
                    if (handleInventoryStatus(item["inventory_status"]) !== Status.doNotDisplay)
                        product.items!.push({
                            sku_id: item["sku_id"],
                            price: item["prices"][0]["include_tax"]["price_formatted"],
                            quantity: item["sizes"][0]["value"],
                            shadeCode: item["shades"][0] ? item["shades"][0]["hex_val"] : undefined,
                            shadeName: item["shades"][0] ? item["shades"][0]["name"] : undefined,
                            image: item["media"]["large"],
                            status: handleInventoryStatus(item["inventory_status"])
                        })
                }
            });

        }

        // If product has no items don't add it
        if (product.items?.length === 0) {
            return
        }

        // Images handling
        if (item["media"]) {
            if (item["media"]["large"]) {
                product.images = item["media"]["large"]
            }
        }

        // Texts handling
        if (item["short_description"]) {
            product.texts.push({
                label: "short_description",
                content: item["short_description"]
            })
        }

        // Time of use handling
        if (item["time_of_use"]) {
            if (item["time_of_use"].length === 1) {
                if (item["time_of_use"][0].key === "night-time") {
                    product.dayNightValue = "night"
                }

                if (item["time_of_use"][0].key === "day-time") {
                    product.dayNightValue = "day"
                }

                if (item["time_of_use"][0].key === "both-time") {
                    product.dayNightValue = "both"
                }
            }

            if (item["time_of_use"].length === 2) {
                product.dayNightValue = "both"
            }
        }

        item["usage"].forEach((text: any) => {
            if (text.content !== null) {
                product.texts?.push({
                    label: text["label"],
                    content: text["content"]
                })
            }
        });

        resProducts.push(product)

    });

    // Ajout de la catégory pour chaque produit
    resProducts.forEach((product) => {
        let baseId = base_IDs.find((element) => element.prodBaseId === product.prod_base_id)
        if (baseId) {
            product.category = baseId.category
            product.priority = baseId.priority
            product.skuID = baseId.skuID ? baseId.skuID : product.prod_base_id
            product.instoreSku = baseId.instoreSku
        }
    })
    let newResProduct: Product[] = []

    if (base_IDs[0].category.includes("dailySpfProtectionQuiz")) {
        console.warn(base_IDs.length)
        newResProduct = enrichProducts(base_IDs, resProducts)
    }

    return newResProduct.length > 0 ? newResProduct : resProducts
}

function enrichProducts(baseIDs: any[], resProducts: Product[]): Product[] {
    // Créer un objet de correspondance pour les resProducts
    const resProductMap = new Map<string, Product>();
    resProducts.forEach(product => resProductMap.set(product.prod_base_id, product));

    // Enrichir les baseIDs avec les informations des resProducts
    const enrichedBaseIds: (Omit<any, 'category'> & Product)[] = baseIDs.map(baseId => {
        const resProduct = resProductMap.get(baseId.prodBaseId);
        return { ...resProduct, ...baseId }; // Notez l'ordre inversé pour écraser 'category' si nécessaire
    });

    return enrichedBaseIds;
}

const getELCMarket = (market: string): string => {
    switch (market) {
        case "SG":
            return "US"
        case "SP":
            return "ES"
        case "UK":
        case "IE":
            return "GB"
        case "EMEA":
            return "FR"
        case "LATAM":
            return "MX"
        case "ASIA":
            if (i18n.language === "CnCn") {
                return "CN"
            } else {
                return "HK"
            }
        default:
            return market
    }
}

const getELCURL = (market: string): string => {

    const usURL = "https://ncsa.sdapi.io/stardust-prodcat-product-v3/graphql/core/v1/extension/v1"
    const euURL = "https://emea.sdapi.io/stardust-prodcat-product-v3/graphql/core/v1/extension/v1"
    const apacURL = "https://apac.sdapi.io/stardust-prodcat-product-v3/graphql/core/v1/extension/v1"
    const cnURL = "https://cnnx.sdapicn.cn/stardust-prodcat-product-v3/graphql/core/v1/extension/v1"

    switch (market) {
        case "FR":
        case "ES":
        case "SP":
        case "UK":
        case "IE":
        case "EMEA":
        case "BE":
        case "AT":
        case "CH":
        case "CZ":
        case "DE":
        case "GR":
        case "HU":
        case "IL":
        case "IN":
        case "IT":
        case "NL":
        case "DK":
        case "NO":
        case "SE":
        case "PL":
        case "RO":
        case "TR":
        case 'ZA':
        case "FI":
            return euURL
        case "US":
        case "CL":
        case "BR":
        case "MX":
        case "CA":
            return usURL
        case "ASIA":
            if (i18n.language === 'ZhHk') {
                return apacURL
            } else {
                return cnURL
            }
        case "CN":
            return cnURL
        case "AU":
        case "NZ":
        case "HK":
        case "KR":
        case "JP":
        case "MY":
        case "TH":
        case "TW":
            return apacURL
        default:
            return usURL
    }
}
